import React from "react";
import fields from "../../json/SmsSettingFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

const SmsConfigForm = ({ 
  values = {}, 
  errors = {}, 
  handleChange, 
  handleSubmit, 
  loading, 
  title = "SMS Configuration", 
  canUpdate = false 
}) => {
  const { SmsConfigFormData } = fields;
  
  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {SmsConfigFormData.map((field) => {
        // Skip hidden ID field in UI
        if (field.name === "id") { return null; }
        
        if (field.type === "switch") {
          return (
            <Switch
              key={field.name}
              values={values[field.name]}
              handleChange={handleChange}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }

        if (field.type === "select") {
          return (
            <div key={field.name} className={field.fieldSize || "col-12"}>
              <label className="form-label">{field.label}</label>
              <select
                name={field.name}
                value={values[field.name] || ""}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">{field.placeholder || "Select..."}</option>
                {field.options?.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              {errors[field.name] && (
                <div className="text-danger small mt-1">{errors[field.name]}</div>
              )}
            </div>
          );
        }

        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name] || ""}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      {canUpdate && (
        <FormSubmitButton
          label={`Update`}
          loading={loading}
          colSize="col-12"
          align="end"
        />
      )}
    </PageBody>
  );
};

export default SmsConfigForm;
